module.exports = __webpack_public_path__ + "static/newbaby1-caf998a7a2cdde9991c7e6eaa380b04a.png";